import {Component, OnInit, Input, ViewChild} from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { EmployeeService } from '../employee.service';
import { NbDialogService } from '@nebular/theme';
import { NewEmployeeComponent } from '../new-employee/new-employee.component';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { EditEmployeeComponent } from '../edit-employee/edit-employee.component';
import { environment } from '../../environments/environment';
import { FilesService } from '../services/files.service';
import { StationService } from '../services/stations.service';
import { ActivatedRoute } from '@angular/router';
import { SysUsersService } from '../services/sys-users.service';

@Component({
  selector: 'ngx-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss'],
})
export class EmployeesComponent implements OnInit {
  source: LocalDataSource;
  loading: boolean = false;
  stationId: string;
  activeTab = 'Empleados';

  @Input() withUrlMinutaCourses: boolean = false;

  @Input() showCreateEmployee: boolean = true;

  @Input() settings: any = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      nns: {
        title: 'Número de trabajador',
        filter: true,
      },
      name: {
        title: 'Nombre',
        filter: true,
      },
      curp: {
        title: 'CURP',
        filter: true,
      },
      role: {
        title: 'Puesto',
        filter: true,
      },
      imss: {
        title: 'NSS (imss)',
        filter: true,
      },
    },
    noDataMessage: 'Sin registros',
  };
  downloading = false;
  dataLoaded = false;
  user = { role: '' }

  constructor(
    private employeeService: EmployeeService,
    private dialogService: NbDialogService,
    private fileService: FilesService,
    private stationService: StationService,
    private route: ActivatedRoute,
    private userService: SysUsersService,

  ) {
    this.stationId =  this.route.snapshot.params.stationId;

    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      await this.init();
      this.activeTab = 'Empleados';
    });
  }

  ngOnInit() {
    this.stationService.checkIfStationIdOrRefirect();
    this.init();
  }

  async init() {
    await this.setUser();
    await this.getEmployees();
  }

  async setUser () {
    const [error, response] = await this.userService.getProfileV2();
    if (error) return error;
    this.user = response.data;
    if (this.user.role === 'viewAndDownloadOnly') {
      this.settings.actions.custom = [];
    }
  }

  async getEmployees() {
    this.loading = true;
    const [error, { data: result }] = await this.employeeService.getEmployees(this.stationId);
    if (error) return error;
    if (this.withUrlMinutaCourses) for await (const employee of result) {
      employee.url = `<img class="hover-cursor-pointer" src="assets/images/icons/download.png" width="25px">`;
      employee.download = await this.generateUrlEmployeeCourses(employee);
    };
    this.source = new LocalDataSource(result);
    this.loading = false;
  }

  async generateUrlEmployeeCourses (data: any) {
    const url = `${environment.baseEndpoint}/filesGeneratorv2/implementation/six/step/two/${data.id}/${this.stationId}`;
    return `<a href="${url}" target="_blank" class="btn btn-primary text-white"><i class="fas fa-file-download download-icon white"></i></a>`;
  }

  async downloadFile(url, name) {
    this.downloading = true;
    await this.fileService.downloadFile(url, name.toLowerCase().replace(' ', '_'));
    this.downloading = false;
  }

  openNewEmployee() {
    this.dialogService.open(NewEmployeeComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(employeeStored => employeeStored ? this.getEmployees() : null);
  }

  onCustom(event: any) {
    if (event.action === 'delete') {
      this.deleteEmployee(event.data.id);
    } else if (event.action === 'edit') {
      this.editEmployee(event.data);
    }
  }

  async editEmployee(employee) {
    this.dialogService.open(EditEmployeeComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        employee: employee,
      },
    }).onClose.subscribe(employeeUpdated => employeeUpdated ? this.getEmployees() : null);
  }

  onUserRowSelectCapacitation(event) {
    if(this.withUrlMinutaCourses) {
      this.downloadFile(event.data.download, event.data.name);
    }
  }

  async downloadListEmployees() {
    this.downloading = true;
    await this.fileService.downloadFile(`${environment.baseEndpoint}/filesGeneratorv2/employees/${this.stationId}`, 'lista_personal');
    this.downloading = false;
  }

  async deleteEmployee(id) {
    Swal.fire({
      title: '¿Estás seguro de eliminar?',
      text: 'Esta acción no se puede revertir',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#dd3333',
      confirmButtonText: 'Borrar',
    }).then(async (result) => {
      if (result.value) {
        const [error] = await this.employeeService.deleteEmployee(this.stationId, id);
        // tslint:disable-next-line: max-line-length
        if (error) return this.alert('Ocurrio un error al intentar borrar el elemento, intenta más tarde por favor', 'error');

        this.alert('Empleado borrado con éxito');
        this.getEmployees();
      }
    });
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  changeTab(event) {
    this.activeTab = event.tabTitle
  }

}
